import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { UpcomingLeave } from "../attendance.types";
import attendance from "../../../resources/attendance";

interface IProps {
    data: UpcomingLeave[];
    isLoading: boolean;
}

interface ILeave {
    empId: string;
    empName: string;
    date: string[];
    description: string;
}

const UpcomingTeamLeavesCard: React.FC<IProps> = (props) => {

    const [leave, setLeave] = useState<ILeave[]>([]);

    const resource = attendance.upcomingLeavesText;

    useEffect(() => {
        filterNextTwoWeeksLeaves(props.data);
    }, [props.data]);

    function filterNextTwoWeeksLeaves(leaves: UpcomingLeave[]) {
        const today = dayjs().startOf("day");
        const endDate = today.add(14, "day");
        const filtered = [...leaves]
            .sort(
                (a, b) =>
                    dayjs(a.leaveDate).valueOf() - dayjs(b.leaveDate).valueOf()
            )
            .filter((leave) => {
                const leaveDate = dayjs(leave.leaveDate);

                return (
                    leaveDate.isSame(today, "day") ||
                    (leaveDate.isAfter(today) &&
                        (leaveDate.isBefore(endDate, "day") ||
                            leaveDate.isSame(endDate, "day")))
                );
            });


        //group leaves for same employee-id
        const grouped = new Map<string, ILeave>();

        filtered.forEach((leave) => {
            if (!grouped.has(leave.employeeId)) {
                grouped.set(leave.employeeId, {
                    empId: leave.employeeId,
                    empName: leave.employeeName,
                    description: resource.approvedLeave,
                    date: [leave.leaveDate],
                });
            } else {
                grouped.get(leave.employeeId)!.date.push(leave.leaveDate);
            }
        });


        setLeave(Array.from(grouped.values()));


    }

    function findDaysRemaining(leaveDate: string[]) {
        const initialDate = dayjs(leaveDate[0]);
        const today = dayjs();

        return initialDate.diff(today, "day");
    }

    function formatDate(leaveDates: string[]) {
        return leaveDates
            .map(date => dayjs(date).format("DD MMM"))
            .join(", ");
    }

    const leaveDescription = (dayDiff: number) => (dayDiff > 0 ? `${dayDiff} days left` : 'On leave Today')

    return (
        <section className="pn-attendance__card upcoming-team-leaves">
            <div className="pn-attendance__card__header">
                <h3 className="pn-attendance__card__title">Upcoming Leaves</h3>
                <span className="pn-attendance__card__subtitle">
                    Next 2 weeks — plan team coverage accordingly.
                </span>
            </div>
            <ul className={'upcoming-team-leaves__list'}>
                {leave.map((item) => (
                    <li key={item.empId} className="upcoming-team-leaves__item">
                        <span className="upcoming-team-leaves__employee-name">
                          {item.empName} —{" "}
                        </span>

                        <span className="upcoming-team-leaves__leave-details">
                           {item.description} —{" "}
                            <span className="upcoming-team-leaves__leave-dates">
                              {formatDate(item.date)}
                          </span>
                       </span>

                        <p className="upcoming-team-leaves__countdown">
                            {leaveDescription(findDaysRemaining(item.date))}
                        </p>
                    </li>
                ))}
            </ul>
        </section>
    )
}

export default UpcomingTeamLeavesCard;
